module.exports = __webpack_public_path__ + "img/3.3.aa4316f9.png";